import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { LanguageTranslation } from '../language-translation.model';

@JsonObject('LanguageTranslationsResultsResponse')
export class LanguageTranslationsResultsResponse extends ApiResultsResponse<LanguageTranslation> {

  @JsonProperty('results', [LanguageTranslation])
  override results: LanguageTranslation[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
